import UploadForm from "./components/UploadForm";
import "./App.css";

function App() {
  return <UploadForm />;
}

export default App;
